export default "__VITE_ASSET__e643f2ff__"